import React, { useEffect } from "react";
import "../../assets/styles/logistics.scss";
import User2Img from "../../assets/images/user-2.svg";
import User3Img from "../../assets/images/user-3.svg";
import User4Img from "../../assets/images/user-4.svg";
import { TabView, TabPanel } from "primereact/tabview";
import ActionLogistic from "./ActionLogistic";
import { commonPostApi, commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import _ from "lodash";
import moment from "moment";
import DateSelection from '../../components/common/dateSelection';
import { Button } from "primereact/button";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { dashoardDetails, Feature } from "../../utils/utils";
import { useSelector } from "react-redux";

const Logistics = () => {
  const [refresh, setRefresh] = React.useState(false);
  const [dateVisible, setDateVisible] = React.useState(false);
  const [checkedData, setCheckedData] = React.useState([]);
  const [cardData, setCardData] = React.useState([]);
  const [date, setDate] = React.useState(new Date());
  const id = useSelector(state => state.common.camp?.camp_details_id);

  const ActionApi = (api, payload, msg) => {
    commonPostApi(api, payload)
      .then((data) => {
        if (data?.data) {
          setRefresh(!refresh);
          showToast(TOAST_TYPE.SUCCESS, msg);
          init();
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      });
  };

  const init = () => {
    commonGetApi(API_ENDPOINTS.PATIENT_TRANSPORTATION_DASHBOARD).then((data) => {
      data?.data?.data && setCardData(data?.data?.data);
    });
  };

  const handleAction = (event, data) => {
    if (_.isEmpty(data)) {
      showToast(TOAST_TYPE.INFO, COMMON_MSG.VALIDATION.SELECT_RECORDS);
      return;
    }
    if (event === "Arrived" || event === "missed") {
      ActionApi(
        API_ENDPOINTS.EDIT_PATIENT_TRANSPORTATION_STATUS,
        {
          patient_transportation_details_ids: data?.map(
            (item) => item?.patient_transportation_details_id
          ),
          status: event === "missed" ? "missed" : "arrived",
        },
        FEATURE_MSG.LOGISTICS.STATUS_UPDATED
      );
    } else if (event === "Schedule") {
      setDateVisible(true);
      setCheckedData(
        data?.map((item) => ({
          patient_transportation_details_id:
            item?.patient_transportation_details_id,
          patient_visit_id: item?.patient_visit_id,
        }))
      );
    }
  };

  const confirm = (props) => {
    confirmDialog({
      message: COMMON_MSG.CONFIRM.MAKE_FOLLOWUP,
      header: COMMON_MSG.CONFIRM.CONFIRMATION_HEADER,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptClassName: "accept",
      accept: () => followUp(props),
    });
  };

  const buttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: () => {
        if (date) {
          ActionApi(
            API_ENDPOINTS.SCHEDULE_NEW_APPOINTMENT,
            {
              appointment_date: moment(date).format("YYYY-MM-DD"),
              patient_data: checkedData,
            },
            FEATURE_MSG.LOGISTICS.TRANSPORTATION_SCHEDULED
          );
          setCheckedData([]);
          setDateVisible(false);
        }
      },
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        setCheckedData([]);
        setDateVisible(false);
      },
    },
  ];

  const followUp = (props) => {
    commonPostApi(API_ENDPOINTS.FOLLOWUP, {
      patient_transportation_details_id:
        props?.props?.itemProp?.patient_transportation_details_id,
    })
      .then((data) => {
        if (data?.response?.data?.message)
          return showToast(TOAST_TYPE.ERROR, data?.response?.data?.message);
        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.LOGISTICS.FOLLOWUP_ADDED);
        setRefresh(!refresh);
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      });
  };

  const itemRender = (data, props) => {
    return (
      <div className="p-menuitem-content">
        <Button
          className="card-button-add"
          icon="pi pi-plus"
          label="Follow Up"
          onClick={() => {
            confirm(props);
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    init();
  }, [id]);

  return (
    <div className="Logistics__main-container">
      <div className="Logistics__card-container">
        <ul className="Logistics__card-holder">
          <li>
            <div className="card-left-sec">
              <p className="card-title">Scheduled</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("scheduled", cardData) || 0}
                </span>
              </p>
              <p className="card-sub-info">Last week analytics</p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-two">
                <img src={User2Img} alt="" />
              </span>
            </div>
          </li>
          <li>
            <div className="card-left-sec">
              <p className="card-title">Arrived</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("arrived", cardData) || 0}
                </span>
              </p>
              <p className="card-sub-info">Last week analytics</p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-three">
                <img src={User3Img} alt="" />
              </span>
            </div>
          </li>
          <li>
            <div className="card-left-sec">
              <p className="card-title">Missed</p>
              <p className="card-info">
                <span className="total-count">
                  {dashoardDetails("missed", cardData) || 0}
                </span>
              </p>
              <p className="card-sub-info">Last week analytics</p>
            </div>
            <div className="card-right-sec">
              <span className="card-icon bg-four">
                <img src={User4Img} alt="" />
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div className="Logistics__table-container">
        <div className="table-header-sec">Patient List</div>
        <div className="tab-view-sec">
          <TabView>
            <TabPanel header="Incoming Appointments">
              <ActionLogistic
                api={API_ENDPOINTS.PATIENT_TRANSPORTATION_DETAILS}
                searchOption={"scheduled"}
                selectable={true}
                current
                refresh={refresh}
                isButtonEnabledLeft={Feature?.featureVerify(Feature.listOfFeature.logisticsIncomArrived)}
                handSecoundaryleClick={(data) => handleAction("missed", data)}
                dataKey={"patient_transportation_details_id"}
                handleAction={handleAction}
              />
            </TabPanel>
            <TabPanel header="Arrived Appointments">
              <ActionLogistic
                api={API_ENDPOINTS.PATIENT_TRANSPORTATION_DETAILS}
                searchOption={"arrived"}
                refresh={refresh}
              />
            </TabPanel>
            <TabPanel header="Missed Appointments">
              <ActionLogistic
                api={API_ENDPOINTS.PATIENT_TRANSPORTATION_DETAILS}
                searchOption={"missed"}
                selectable={true}
                isButtonEnabledLeft={Feature?.featureVerify(Feature.listOfFeature.logisticsMissedSchedule)}
                currentPageHeader={"Schedule"}
                refresh={refresh}
                columnArray={["no_of_followup_calls"]}
                optionsView={Feature?.featureVerify(Feature.listOfFeature.logisticsMissed) && [
                  {
                    items: [
                      {
                        label: "Add visit",
                        icon: "pi pi-pencil",
                        template: itemRender,
                      },
                    ],
                  },
                ]}
                handleAction={handleAction}
              />
            </TabPanel>
          </TabView>
        </div>
        {dateVisible && (
          <DateSelection
            visible={dateVisible}
            onHide={() => {
              setCheckedData([]);
              setDateVisible(false);
            }}
            date={date}
            setDate={setDate}
            minDate={new Date()}
            buttons={buttons}
          />
        )}
      </div>
      <ConfirmDialog />
    </div>
  );
};
export default Logistics;
